<template>
  <div class="modal-bg">
    <div class="overview-wrapper">
      <div class="row">
        <div class="title">
          <h4>
            <strong>{{ t("message.importOverview") }}</strong>
          </h4>
        </div>
        <button class="close btn btn-danger" @click="$emit('close')">X</button>
      </div>
      <div
        class="preview-container"
        :class="{ 'preview-small': imported.length < 6 }"
        :style="{
          width: imported.length < 6 ? imported.length * 16.66 + '%' : '',
          'min-width': '35%',
        }"
      >
        <div
          class="preview"
          v-for="(inlay, index) in imported"
          :key="inlay.name"
          @click="selectInlay(inlay, index)"
        >
          <glass-taster
            :gt="inlay"
            :editor="false"
            class="gt-shadow"
            :class="[{ selected: selectedInlays.includes(index) }]"
          ></glass-taster>
          <div class="row text-center p-2 inlayname text-break">
            <div>{{ inlay["project-name"] }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, reactive, onMounted } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import GlassTaster from "../../components/GTComponent.vue";

export default {
  components: { GlassTaster },
  props: { imported: Array },
  setup(props, context) {
    onMounted(() => {
      props.imported.forEach((inlay) => {
        console.log(inlay);
      });
    });
    const store = useStore();
    const currentProject = computed(() => store.getters.currentProject);
    const { t } = useI18n();
    const selectedInlays = ref([]);

    function selectInlay(inlay, index) {
      let inlayIdx = currentProject.value.findIndex(
        (el) => inlay["project-name"] == el["project-name"]
      );
      context.emit("selectImport", inlayIdx);
      if (!selectedInlays.value.includes(index)) {
        selectedInlays.value.push(index);
      } else {
        selectedInlays.value.splice(selectedInlays.value.indexOf(index), 1);
      }
    }
    return { currentProject, t, selectInlay, selectedInlays };
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/style.scss";
@media (min-resolution: 108dpi) {
  .overview-wrapper {
    height: 94vh !important;
    width: 85vw !important;
    top: 5% !important;
    padding: 0.4% 1.5% !important;
  }
  .preview-container {
    // padding-top: 5px !important;
  }
  .preview:hover {
    transform: scale(1.02) !important;
  }
  .gt-shadow {
    margin-top: 10px;
  }
}
.preview {
  // padding: 0 3rem;
  // margin: auto;
  > div {
    cursor: pointer;
  }
  overflow-x: hidden;
  flex: 1 0 0;
  // transform: scale(0.9);
  transition: 0.7s;
  &:hover {
    overflow-x: visible;
    padding: 0 15px;
    transform: scale(1.05);
    .inlayname {
      visibility: visible;
    }
  }
  &:last-child {
    flex: 0 0 auto;
  }
  .inlayname {
    visibility: hidden;
  }
}
.preview-container {
  min-height: 630px;
  // padding-top: 50px;
  display: flex;
}
.gt-shadow:hover {
  -webkit-box-shadow: 0px 5px 15px 5px rgba(92, 92, 92, 0.28);
  box-shadow: 0px 5px 15px 5px rgba(92, 92, 92, 0.28);
}
.overview-wrapper {
  height: 78vh;
  width: 85vw;
  position: absolute;
  top: 10%;
  left: 10%;
  background: white;
  overflow-y: auto;
  overflow-x: hidden;
  opacity: 1;
  padding: 1% 3%;
}
.modal-bg {
  height: 100vh;
  width: 100vw;
  //TODO: change to rgba for opacity
  background: black;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 500;
}
.close {
  width: 3%;
  left: 96%;
  top: 0.5%;
  position: fixed;
}
.selected {
  border: 2px solid $lcn-primary;
}
.title {
  border-bottom: 1px solid #eee;
}
.preview-small {
  // width: 50vw;
  margin: auto;
}
</style>
